// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9837bc10","90":"36e4b6e4","212":"5585dcee","281":"09da27b5","769":"3542f97c","775":"ec393524"}[chunkId] + ".chunk.js";
};